import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdCustomRolesCreateCustomRoleCacheKeys: AllRouteEndpoints[] = [];
